/**
 * App - 全局应用对象
 *
 * 所有模块共享同一个 App 对象，确保 this 引用正确
 */

export const App: any = {};

export default App;
